<template>
  <form class="question-content" id="q1Content" @submit="checkForm()">
    <v-container fluid grid-list-md>
		<div id="q1Errs" style="width:100%;height:15px;"></div>
      	<err-panel :id="qId" v-on:closepanel = "onClosePanel" v-on:closeerrorpanel = "onErrorPanelCleared"></err-panel>
      	<wes-q-text v-bind:metadata="question"></wes-q-text>
      	<v-layout>
					<v-flex v-if="displayLayout && answerLayout && displayLayout != answerLayout.displayLayouts.I" xs12>
					</v-flex>
				</v-layout>

				<organization-search-tool v-if="displayLayout && answerLayout && displayLayout == answerLayout.displayLayouts.I"
				v-on:addClick="addOrganizationColumn"
				v-on:closeSnack="closeSnack"
				:snackMessage="snackMessage"
				:snackbarHolder="snackbar"
				:snackColor="snackColor"
				:disabled="isSearthToolDisabled"
				@dialog-changed="handleDialogChange"
				v-on:save="onSaveClicked(qId)">
				</organization-search-tool>

			<div class="scroll-container">
			<br />

		<v-layout>
				<answer-columns class="margin-left" v-bind:columns="columns" v-bind:qId="qId" v-bind:columnHeader="columnHeader" />
			</v-layout>
			<v-layout>
				<answer-matrix
					class="margin-left"
					:displayLayout="displayLayout"
					:layout="answerLayout"
					:qId="question.displayId"
					:columns="columns"
					:crossCheck="crossCheck"
					:hasExp="hasExp"
					v-on:update="onUpdateAnswer"
					v-on:save="onSaveClicked"
					v-on:update:disable:search="onDisableUpdate">
				</answer-matrix>
			</v-layout>
			<br />
		</div>

		<v-layout>
			<answer-explain
				v-if="displayLayout != null && answerLayout && displayLayout != answerLayout.displayLayouts.E && displayLayout != answerLayout.displayLayouts.D && displayLayout != answerLayout.displayLayouts.H"
				:label="question.explanation.label"
				:explanation=" answerLayout && answerLayout.answer && answerLayout.answer.length > 0 ? answerLayout.answer[0].expBox : '' "
				v-on:update="updateExpBox">
			</answer-explain>
			<answer-explain
				v-if="displayLayout != null && answerLayout && displayLayout == answerLayout.displayLayouts.D && displayLayout != answerLayout.displayLayouts.H"
				:label="question.explanation.label"
				:explanation=" answerLayout && answerLayout.answer && answerLayout.answer.length > 0 ? answerLayout.answer[0].a.expBox : '' "
				v-on:update="updateExpBox">
			</answer-explain>
		</v-layout>

		<v-layout>
			<v-flex xs12>
				<div style="text-align:left" v-if="displayLayout != null && answerLayout && displayLayout != answerLayout.displayLayouts.E && displayLayout != answerLayout.displayLayouts.H">
				 	<v-btn :class="isSurveyLocked" color="primary" dark v-on:click="isSurveyLocked==null && onSaveClicked(qId, answerLayout.answer[0].expBox, null)">Save</v-btn>
					&nbsp;<span style="text-align:left;color:red" id="span_Id" v-if="displayLayout == answerLayout.displayLayouts.A"></span>
					&nbsp;<span style="text-align:left;color:blue;" id="surveyLockedDisplayText" v-if="isSurveyLocked!=null">Survey has been submitted and locked.</span>
					&nbsp;<span style="text-align:left;color:blue;" id="isProcessing">{{ isProcessing }}</span>
				</div>
				<div style="text-align:left" v-if="displayLayout != null && answerLayout && displayLayout == answerLayout.displayLayouts.E && displayLayout != answerLayout.displayLayouts.H">
					<v-btn :class="isSurveyLocked" color="primary" dark v-on:click="isSurveyLocked==null && onSaveClicked(qId, answerLayout.answer[0].expBox1, answerLayout.answer[0].expBox2)">Save</v-btn>
					&nbsp;<span style="text-align:left;color:blue;" id="surveyLockedDisplayText" v-if="isSurveyLocked!=null">Survey has been submitted and locked.</span>
					&nbsp;<span style="text-align:left;color:blue;" id="isProcessing">{{ isProcessing }}</span>
				</div>
			</v-flex>
		</v-layout>
    </v-container>
    <help-panel
      v-if="bDisplayHelp===true"
      v-on:closepanel="onClosePanel"
      v-bind:question="question"
    ></help-panel>
    <loader v-if="loading"></loader>
  </form>
</template>

<script>
import { questionMixins } from './mixins/questionMixins';
import { utilityService } from './../../services/utilityService';
import { surveyService } from '@/services/surveyService';
import { authTokenService } from '@/services/authTokenService.js';
import { userService } from "../../services/userService.js";

export default {
  name: 'Question',
	mixins: [questionMixins],
  props: {
    question: Object,
    qId: String,
		isStandardSurvey: Boolean,
		savemessage: String
  },
  data: () => ({
    isHelpDisplayed: false,
    x: '',
		section: null,
		columns: [],
		columnHeader: null,
		answersMatrix: null,
		myProps: {},
		loading: true,
		displayLayout: null,
		snackMessage: "Default",
		snackbar: false,
		snackColor: "info",
		hasExp: null,
		isSearthToolDisabled: false,
		isLocked: false,
		isSurveyLocked: null,
		nonAdmin: false,
		alertmessage: null,
		isProcessing: null
  }),
  created () {
		console.log('Question ' + this.qId + ' created');
  },
  mounted () {
		this.nonAdmin = authTokenService.getNotaAdmin();
	 	this.isLocked = this.setIsLocked();
  },
  methods: {
		reload () {
			window.location.reload();
		},
	  setIsLocked: function () {
      const me = this;
      me.activeId = authTokenService.getActiveSurveyId();
        surveyService.getLockStatus(me.activeId).then(function (response) {
          if (response && response.data != null) {
            if (response.data.isLocked == true) {
                me.isLocked = true;
                me.isSurveyLocked = "isDisabled";
            } else if (response.data.currentUser != null) {
              me.isLocked = true;
            } else {
              me.isLocked = false;
			  			me.isSurveyLocked = null;
			  			if (!me.nonAdmin) {
			  				me.isLocked = me.disableInCaseOfPreviousVolume();
							}
            }
          }
        })
        .catch(function (e) {
          console.log(e);
          console.log('Error loading survey lock status')
          throw e;
        });
        return me.isLocked;
      },
	  disableInCaseOfPreviousVolume: function () {
			const me = this;
			const cVolume = authTokenService.getCurrentVolume();
			userService.getVolumeConfig().then(function (response) {
			if (response && response.data != null) {
				if (response.data.volume !== cVolume) {
					me.isLocked = true;
					me.isSurveyLocked = "isDisabled";
				} else {
					me.isLocked = false;
					me.isSurveyLocked = null;
				}
			}
		});
		return me.isLocked;
	},
      hideModal () {
        this.$refs['my-modal'].hide();
      },
    onUpdateAnswer: function (val) {
      this.updateAnswer(val);
			console.log(val);
    },
		 onSaveClicked: function (val, expval, expval2) {
			  this.isProcessing = "Processing please wait. Note:In case of continuous inprogress, please click save or home button again.";
				this.isStandardSurvey = this.$store.getters['isSurveyType'];
				if (val === "4") {
					this.saveAnswer(val, expval, "", this.answerLayout.answer[0].fy1Con, this.answerLayout.answer[0].fy1Pla, this.isStandardSurvey);
				} if (val === "2") {
					this.saveAnswer(val, expval, expval2, "", "", this.isStandardSurvey);
				}	else {
					this.saveAnswer(val, expval, "", "", "", this.isStandardSurvey);
				}
				setTimeout(() => { this.isProcessing = null }, 3500);
			},
    onInput: function (field, evt) {
      this.inputChanged(field, evt);
    },
    onClosePanel: function () {
			// TODO this may need something to clear the validation messages
      this.isHelpDisplayed = false;
    },
    onErrorPanelCleared: function () {
      // this.isErrorsOverlayDisplayed = false;
    },
    onHandleHelpClicked: function (bDisplay) {
      this.isHelpDisplayed = bDisplay;
		},
		updateExpBox: function (evt) {
			this.answerLayout.answer[0].expBox = evt.exp;
			if (!this.answerLayout.answer[0].expBox || this.answerLayout.answer[0].expBox.length == 0) {
				this.hasExp = false;
			}	else {
				this.hasExp = true;
			}
		},
		addOrganizationColumn (evt) {
			this.isStandardSurvey = this.$store.getters["isSurveyType"];
			var allAnswers = this.$store.getters["answersArray"];
			var orgSections = utilityService.getOrganizationSections();
			var selectedSection = null;
			var type = (evt && evt.type && evt.type.toLowerCase()) || "";
			if (this.qId == 18 || this.qId == 20) {
				if (type.includes("academic")) {
				selectedSection = orgSections.DOD.academic;
				selectedSection = this.qId;
				this.pushOrgArray(allAnswers, selectedSection, evt);
			} else {
						this.errorInfo(evt, this.qId, "nonprofit to academic");
					}
						}
				if (this.qId == 19 || this.qId == 21) {
					if (type.includes("nonprofit")) {
						selectedSection = orgSections.Standard.nonprofit;
						selectedSection = this.qId;
					this.pushOrgArray(allAnswers, selectedSection, evt);
			} else {
			this.errorInfo(evt, this.qId, "academic to nonprofit");
			}
		}
	},
		findOrgRow: function (selectedAnswer, evt, section) {
			var found = false;

			if (selectedAnswer[0].pla == Number.MIN_SAFE_INTEGER) {
				found = true;
				this.errorSnackNA(evt, section);
			}

			for (var i = 0; i < selectedAnswer.length && !found; i++) {
				if (selectedAnswer[i].orgCod == evt.code) {
					found = true;
					// display error message if it already exists
					this.errorSnackDuplicate(evt, section);
				}
			}
			return found;
		},
		pushOrgArray: function (allAnswers, selectedSection, evt) {
			const selectedAnswer = allAnswers[selectedSection];
			// Safety check: ensure array exists
			if (!Array.isArray(selectedAnswer)) {
				console.error("Invalid selectedAnswer array for section:", selectedSection);
			return;
			}
			// Normalize type safely
			const type = evt && evt.type ? evt.type.toLowerCase() : "";
		// Prevent duplicates
			if (this.findOrgRow(selectedAnswer, evt, selectedSection)) {
			return;
			} // Ensure template row exists
			if (!selectedAnswer[0]) {
				console.error("Template row missing for section:", selectedSection);
			return;
			}
				// Clone template row
		const temp = JSON.parse(JSON.stringify(selectedAnswer[0]));
		// Reset values
		for (const key in temp) {
			if (!temp.hasOwnProperty(key)) {
				continue;
			}
			const val = temp[key];
			if (typeof val === "number") {
				temp[key] = 0;
			} else if (typeof val === "string") {
					temp[key] = null;
				} else if (Array.isArray(val)) {
						temp[key] = [];
					} else if (typeof val === "object" && val !== null) {
							temp[key] = null;// safer than forcing to 0
							}
						} // Assign new values
							temp.status = "InProgress";
							temp.orgCod = evt.code; // Academic / Nonprofit logic
							if (type.includes("academic") && (selectedSection == 18 || selectedSection == 20)) {
								temp.insCon = evt.name;
							}
								if (type.includes("nonprofit") && (selectedSection == 19 || selectedSection == 21)) {
									temp.orgCon = evt.name;
								}
									temp.createDate = "0001-01-01T00:00:00";
									temp.updateDate = "0001-01-01T00:00:00";
									selectedAnswer.push(temp);
								// Notify user
							this.successSnack(evt, selectedSection);
		},
		closeSnack: function () {
			this.snackbar = false;
		},
		successSnack: function (evt, section) {
			console.log("Row added");
			// this.snackMessage = "Question " + section + ": Added " + evt.code + ", " + evt.name + "🠞 " + section";
			// TOOD: not sure the html arrow charcter will work (beyond Chrome) so need to explore how to use a char entty
			this.snackMessage = "Added " + evt.code + ", " + evt.name + " ➜ Question " + section;
			this.snackColor = "success";
			this.snackbar = true;
		},
		errorSnackDuplicate: function (evt, section) {
			console.log("Row already exists");
			// this.snackMessage = "Question 🠪" + section + ": Already added " + evt.code + ", " + evt.name;
			this.snackMessage = "Already added " + evt.code + ", " + evt.name + " ➜ Question " + section;
			this.snackColor = "red darken-3";
			this.snackbar = true;
		},
		errorSnackNA: function (evt, section) {
			console.log("Section is checked for N/A");
			this.snackMessage = "Unable to complete" + " ➜ Question " + section + " is set to N/A";
			this.snackColor = "red darken-3";
			this.snackbar = true;
		},
		onDisableUpdate: function (evt) {
			this.isSearthToolDisabled = evt;
		},
		errorInfo: function (evt, section, intitutionType) {
			this.snackMessage = "Cannot add " + evt.code + ", " + evt.name + " ➜ Question " + section + " " + intitutionType;
			this.snackColor = "red darken-3";
			this.snackbar = true;
		},
		handleDialogChange (isOpen) {
			this.$store.commit('setIsLoading', { isLoading: false });
			console.log("Dialog state:", isOpen);
			// You can refresh UI or trigger logic here if needed
		}
  },
  computed: {
    bDisplayHelp: function () {
      return this.isHelpDisplayed;
    },
    filteredColHeaders () {
      return this.colHeaders.slice(1, 3);
		},
		crossCheck () {
			return this.question.crossCheck ? this.question.crossCheck : null;
		}
  }
};
</script>

<style scoped>
.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}
.buttonlink {
  text-decoration: none;
  background-color: #1976D3;
  color: White;
  padding: 11px 10px 11px 10px;
  border-top: 1px solid #1976D3;
  border-right: 1px solid #1976D3;
  border-bottom: 1px solid #1976D3;
  border-left: 1px solid #1976D3;
  border-radius: 6px;
}

.column-header {
  font-weight: bold;
  text-align: center;
}
.row-header {
    /*GBC line-height: 48px;*/
    font-weight: bold;
    font-size: 16px;
}
.buttons-container > .right_button {
  float: left;
}
.question-content {
  text-align: left;
  /* background-color: #598dc233; */
  /* border: 2px solid #13314f; */
  /* border-radius: 5px; */
  position: relative;
  color: black;
}
.question-content > h1 {
  margin: 5px 0;
}
.question-content > p,
.question-content > ul {
  margin: 5px 10px;
}
.value-list {
  list-style: lower-latin;
}
.row-label {
  margin: 0px 0px 0px 20px;
  font-weight: normal;
  font-size: 18px;
  /*GBC line-height: 66px;*/
  font-weight: bold;
}
.buttons-container > .button {
  float: right;
}
.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: purple;
}
.v-input--is-focused > .v-input__control > .v-input__slot {
  border: 2px solid red;
}
.help-ico {
  font-size: 40px;
  /*GBC line-height: 44px;*/
  color: #0000ffa3;
}
.scroll-container {
	/* overflow-x: auto;
	border: 1px solid rgb(170, 168, 168);
	height: 75vh;  */
}
.margin-left {
   margin-left: 25px;
}
div.spannote {
  position: relative;
  width: 1020px;
  height: 37px;
  border: 3px solid red;
  text-align:left;
}

</style>
